
enum CompanyHotelParsingSettingState {
    INACTIVE = 'INACTIVE', PENDING = 'PENDING', PROCESSING = 'PROCESSING', ACTIVE = 'ACTIVE', CAN_BE_ACTIVATED = 'CAN_BE_ACTIVATED'
}

export default CompanyHotelParsingSettingState;